import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Input, Switch, message, Tag } from 'antd';
import { EditOutlined, SaveOutlined } from '@ant-design/icons';
import { getNotificationTemplates, updateNotificationTemplate } from '../../api/settings';

const NotificationTemplatesTab = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form] = Form.useForm();

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const res = await getNotificationTemplates();
      setTemplates(res.data);
    } catch (error) {
      message.error('Şablonlar yüklenemedi.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleEdit = (template) => {
    setEditingId(template.id);
    form.setFieldsValue(template);
  };

  const handleSave = async (values) => {
    try {
      await updateNotificationTemplate(editingId, values);
      message.success('Şablon güncellendi.');
      setEditingId(null);
      fetchTemplates();
    } catch (error) {
      message.error('Güncelleme başarısız.');
    }
  };

  const typeLabels = {
    lesson_reminder: 'Ders Hatırlatması',
    // Push bildirimi olarak GÖNDERİLMİYOR — yalnızca takvimdeki WhatsApp
    // ikonu bu metni kullanıyor (deneme dersine gelen veliye konum vb.
    // bilgiler de yazılıyor). Buradan düzenlenmesi için listede duruyor.
    trial_lesson_reminder: 'Deneme Dersi Hatırlatması (WhatsApp)',
    // Bu ikisi de bildirim DEĞİL — ekranda gösterilen/elle gönderilen metin.
    // Burada duruyorlar çünkü kurumun metin düzenleyebildiği tek ekran burası.
    // Etiketi olmayan tür ham anahtarıyla ("parent_portal_info") görünüyordu.
    parent_portal_info: 'Veli Portalı Tanıtım Mesajı (WhatsApp)',
    // PASİFE ALINIRSA veli ödeme ekranındaki kutu tamamen kaybolur —
    // yazılım geçişi eskidiğinde notu böyle kaldırın.
    parent_payment_notice: 'Ödeme Ekranı Bilgi Notu (veliye görünür)',
    present: 'Sertifika Programı Dersine Geldi',
    absent: 'Sertifika Programı Dersine Gelmedi',
    certificate_ready: 'Sertifika Hazır',
    payment_overdue: 'Ödeme Hatırlatması',
    new_term: 'Yeni Dönem Kaydı',
    schedule_change: 'Ders Programı Değişikliği',
    missing_attendance: 'Yoklama Eksik Dersleri',
    student_video_uploaded: 'Yeni Video Yüklendi',
    task_assigned: 'İş Atandı',
    task_completed: 'İş Tamamlandı',
    task_note_added: 'İş Notu Eklendi',
    cron_health_issue: 'Zamanlanmış Görev Sorunu',
  };

  return (
    <div>
      {loading && <p className="text-gray-400">Yükleniyor...</p>}
      {templates.map((template) => (
        <Card
          key={template.id}
          className="mb-4"
          title={
            <div className="flex items-center gap-2">
              <span>{typeLabels[template.type] || template.type}</span>
              <Tag color={template.is_active ? 'green' : 'red'}>
                {template.is_active ? 'Aktif' : 'Pasif'}
              </Tag>
            </div>
          }
          extra={
            editingId === template.id ? (
              <Button
                type="primary"
                icon={<SaveOutlined />}
                size="small"
                onClick={() => form.submit()}
              >
                Kaydet
              </Button>
            ) : (
              <Button
                icon={<EditOutlined />}
                size="small"
                onClick={() => handleEdit(template)}
              >
                Düzenle
              </Button>
            )
          }
        >
          {editingId === template.id ? (
            <Form form={form} layout="vertical" onFinish={handleSave}>
              <Form.Item name="title_template" label="Başlık Şablonu">
                <Input />
              </Form.Item>
              <Form.Item name="body_template" label="İçerik Şablonu">
                <Input.TextArea rows={3} />
              </Form.Item>
              <Form.Item name="is_active" label="Durum" valuePropName="checked">
                <Switch checkedChildren="Aktif" unCheckedChildren="Pasif" />
              </Form.Item>
              <p className="text-gray-400 text-sm mt-2">
                Kullanılabilir değişkenler:{' '}
                {template.available_keys?.length > 0
                  ? template.available_keys.join(', ')
                  : 'Bu şablon için tanımlı değişken yok.'}
              </p>
              {template.usage_source && (
                <p className="text-gray-400 text-xs mt-1">{template.usage_source}</p>
              )}
            </Form>
          ) : (
            <div>
              <div className="mb-2">
                <strong>Başlık:</strong> {template.title_template}
              </div>
              <div>
                <strong>İçerik:</strong> {template.body_template}
              </div>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
};

export default NotificationTemplatesTab;